import { Type } from 'class-transformer';
import { ProjectTaskItemResultDto } from './project-task-item-result-dto';

export class ProjectTaskResultDto {
    allowAddProjectTask: boolean;

    @Type(() => ProjectTaskItemResultDto)
    items: Array<ProjectTaskItemResultDto>;
}
